module.exports = __webpack_public_path__ + "img/avater.6e0a8afc.jpeg";